export default {
  mounted() {
    this.width = window.innerWidth
    this.breakpoint = this.getBreakpoint(this.width)
    window.addEventListener('resize', this.onWindowResize)
  },
  destroyed() {
    window.removeEventListener('resize', this.onWindowResize)
  },
  data() {
    return {
      width: null,
      breakpoint: null,
    };
  },
  computed: {
    $screenWidth() {
      return this.width
    },
    $screenBreakpoint() {
      return this.breakpoint
    },
  },
  methods: {
    onWindowResize() {
      this.width = window.innerWidth;
      this.breakpoint = this.getBreakpoint(this.width)
    },
    getBreakpoint(width) {
      if (width >= 1200) return 'xl'
      else if (width >= 992) return 'lg'
      else if (width >= 768) return 'md'
      else if (width >= 576) return 'sm'
      else return 'xs'
    }
  },
}


// WEBPACK FOOTER //
// /src/screenSize.js